import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    keywords?: string;
    image?: string;
    url?: string;
    type?: string;
}

const SEO: React.FC<SEOProps> = ({
    title,
    description,
    keywords,
    image,
    url,
    type = 'website'
}) => {
    const siteTitle = "D'mans | Heritage & Luxury Furniture";
    const defaultDescription = "Experience the legacy of D'mans Furniture, crafting heritage and luxury furniture since 1925. Discover bespoke designs that blend tradition with modern elegance.";
    const defaultKeywords = "luxury furniture, heritage furniture, bespoke furniture, handcrafted furniture, D'mans furniture, Indian furniture design";
    const siteUrl = "https://dmansfurniture.com";
    const defaultImage = `${siteUrl}/og-image.jpg`; // Ensure this image exists in public folder

    const metaTitle = title ? `${title} | D'mans` : siteTitle;
    const metaDescription = description || defaultDescription;
    const metaKeywords = keywords || defaultKeywords;
    const metaImage = image || defaultImage;
    const metaUrl = url ? `${siteUrl}${url}` : siteUrl;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{metaTitle}</title>
            <meta name="title" content={metaTitle} />
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={metaKeywords} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={metaUrl} />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={metaImage} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={metaUrl} />
            <meta property="twitter:title" content={metaTitle} />
            <meta property="twitter:description" content={metaDescription} />
            <meta property="twitter:image" content={metaImage} />

            {/* Canonical URL */}
            <link rel="canonical" href={metaUrl} />
        </Helmet>
    );
};

export default SEO;
